import React from 'react';
import {
  Search, User, X, Wallet, Activity, Banknote
} from 'lucide-react';

const UserSearchPanel = ({
  searchQuery,
  onSearchChange,
  users,
  usersLoading,
  selectedUser,
  onSelectUser,
  onClearUser,
  userBalance,
  formatCurrency,
}) => {
  const handleSelect = (user) => {
    onSelectUser(user);
  };

  return (
    <div className="left-panel">
      {/* ---- Search Panel ---- */}
      <div className="panel">
        <div className="panel-header">
          <h3><Search /> Find User</h3>
        </div>
        <div className="panel-body">
          <div className="search-box">
            <Search className="search-icon" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Username, email, or wallet..."
              autoComplete="off"
            />
          </div>

          {/* Results dropdown */}
          {users && users.length > 0 && (
            <div className="search-results">
              {users.map((user) => (
                <div
                  key={user.id}
                  className="result-item"
                  onClick={() => handleSelect(user)}
                >
                  <div className="result-item-left">
                    <div className="result-avatar">
                      {user.username?.charAt(0) || '?'}
                    </div>
                    <div className="result-info">
                      <div className="result-name">{user.username}</div>
                      <div className="result-sub">{user.id}</div>
                    </div>
                  </div>
                  <span className="result-type">{user.type}</span>
                </div>
              ))}
            </div>
          )}

          {/* Empty search hint */}
          {!selectedUser && !users && (
            <div className="empty-hint">
              <Search />
              <p>Search for a user to get started</p>
            </div>
          )}
        </div>
      </div>

      {/* ---- Selected User Card ---- */}
      {selectedUser && (
        <div className="panel">
          <div className="panel-header">
            <h3><User /> Selected User</h3>
            <button className="user-card-clear" onClick={onClearUser} title="Deselect">
              <X />
            </button>
          </div>
          <div className="panel-body user-card">
            {/* Header */}
            <div className="user-card-header">
              <div className="user-card-avatar">
                <User />
              </div>
              <div className="user-card-meta">
                <div className="user-card-name">{selectedUser.username}</div>
                <div className="user-card-id">{selectedUser.id}</div>
                <div className="user-card-badges">
                  {selectedUser.isVerified
                    ? <span className="badge green">Verified</span>
                    : <span className="badge yellow">Unverified</span>
                  }
                  {selectedUser.isBlocked
                    ? <span className="badge red">Blocked</span>
                    : <span className="badge blue">Active</span>
                  }
                  <span className="badge blue">{selectedUser.type}</span>
                </div>
              </div>
            </div>

            {/* Balance Mini Cards */}
            <div className="user-card-balance-row">
              <div className="user-balance-mini">
                <div className="mini-label">
                  <Wallet size={10} style={{ display: 'inline', marginRight: 2 }} />
                  Balance
                </div>
                <div className="mini-value green">
                  {userBalance
                    ? formatCurrency(userBalance.balance || userBalance.currentBalance, userBalance.currency)
                    : '—'}
                </div>
              </div>
              <div className="user-balance-mini">
                <div className="mini-label">
                  <Activity size={10} style={{ display: 'inline', marginRight: 2 }} />
                  Status
                </div>
                <div className="mini-value blue">
                  {userBalance?.accountStatus || 'Active'}
                </div>
              </div>
              <div className="user-balance-mini">
                <div className="mini-label">
                  <Banknote size={10} style={{ display: 'inline', marginRight: 2 }} />
                  Currency
                </div>
                <div className="mini-value purple">
                  {userBalance?.currency || 'USD'}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSearchPanel;
